/**
 * Encodes a URL for Graph's `/shares/{token}` path: `u!` followed by the unpadded,
 * URL-safe base64 of the URL's UTF-8 bytes (Graph docs, "Encoding sharing URLs").
 * Accepts sharing links and direct item URLs alike.
 */
export const encodeSharingUrl = (url: string): string => {
    const utf8 = unescape(encodeURIComponent(url));
    const base64 = btoa(utf8);
    return `u!${base64.replace(/=+$/, "").replace(/\//g, "_").replace(/\+/g, "-")}`;
};
